import { action, computed, thunk } from 'easy-peasy'

import { AuthStatus, FormStatus } from '@/types'
import { setHeaderSubscribe, setSubscribeToken } from '@/utils'

import { AuthModel, service } from '.'
import { AxiosError } from 'axios'

export const auth: AuthModel = {
	status: FormStatus.IDLE,
	auth: AuthStatus.UNAUTHENTICATED,
	error: '',

	/** Computed */
	isAuthenticated: computed(state => state.auth === AuthStatus.AUTHENTICATED),

	/** Action */
	setStatus: action((state, payload) => {
		state.status = payload
	}),
	setAuth: action((state, payload) => {
		state.auth = payload
	}),
	setError: action((state, payload) => {
		state.error = payload
	}),

	/** Thunks */
	login: thunk(async (action, payload) => {
		try {
			action.setStatus(FormStatus.LOADING)

			const res = await service.login(payload)
			const { data } = res
			action.loggedIn(data.access_token)
			action.setStatus(FormStatus.SUCCESS)
		} catch (e) {
			action.setStatus(FormStatus.ERROR)
			if (e instanceof AxiosError) {
				action.setError(
					e?.response?.data?.message ||
						(navigator.onLine ? 'Server Error' : 'Network Error')
				)
			}
		} finally {
			setTimeout(() => {
				action.setError('')
				action.setStatus(FormStatus.IDLE)
			}, 1)
		}
	}),
	loggedIn: thunk(async (action, payload) => {
		await Promise.all([setSubscribeToken(payload), setHeaderSubscribe(payload)])
		action.setAuth(AuthStatus.AUTHENTICATED)
	})
}
